import { Carousel } from 'antd';
import { useLocation } from 'react-router-dom'
import { caseList1, caseList5, caseList2, caseList3, caseList4 } from '../utils/products'

import styles from './SettingsDetail.module.scss'
function SettingsDetail() {
  let cases = []
  const { pathname } = useLocation();
  const dashKey = pathname.split('/')[2];
  if (!dashKey) {
    return <div>404</div>;
  }
  if (dashKey === '1') {
    cases = caseList1
  } else if (dashKey === '5') {
    cases = caseList5
  } else if (dashKey === '2') {
    cases = caseList2
  } else if (dashKey === '3') {
    cases = caseList3
  } else if (dashKey === '4') {
    cases = caseList4
  }

  return <div className={styles.settingsDetail}>
    <Carousel autoplay>
      {cases.map(item => <div className={styles.carousel_item}>
        <img src={item.img} />
        <div className={styles.carousel_title}>{item.title}</div>
      </div>
      )}
    </Carousel>
  </div>;
}

export default SettingsDetail;